function getWorkplaceNumbers(workplaces) {
	return (workplaces ?? [])
		.map((workplace) => workplace.external_id)
		.filter(Boolean)
		.join(', ');
}

export function getColumns(
	professionDict,
	divisionDict,
	setSelectedUser,
	setCreateModalOpen,
	setDeleteModalOpen,
	styles
) {
	return [
		{
			title: 'Фамилия',
			dataIndex: 'last_name',
			key: 'last_name',
			sorter: (a, b) => a.last_name.localeCompare(b.last_name)
		},
		{
			title: 'Имя',
			dataIndex: 'name',
			key: 'name',
			sorter: (a, b) => a.name.localeCompare(b.name)
		},
		{
			title: 'Отчество',
			dataIndex: 'father_name',
			key: 'father_name',
			sorter: (a, b) => a.father_name.localeCompare(b.father_name)
		},
		{
			title: 'Профессия',
			dataIndex: 'profession_id',
			key: 'profession_id',
			sorter: (a, b) => {
				const nameA = professionDict[a.profession_id]?.['title'] || '';
				const nameB = professionDict[b.profession_id]?.['title'] || '';
				return nameA.localeCompare(nameB);
			},
			render: (profession_id) => professionDict[profession_id]?.['title'] ?? '—'
		},
		{
			title: 'Подразделение',
			dataIndex: 'division_id',
			key: 'division_id',
			sorter: (a, b) => {
				const nameA = divisionDict[a.division_id]?.['title'] || '';
				const nameB = divisionDict[b.division_id]?.['title'] || '';
				return nameA.localeCompare(nameB);
			},
			render: (division_id) => divisionDict[division_id]?.['title'] ?? '—'
		},
		{
			title: 'Рабочее место',
			dataIndex: 'workplaces',
			key: 'workplaces',
			sorter: (a, b) => getWorkplaceNumbers(a.workplaces)
				.localeCompare(getWorkplaceNumbers(b.workplaces)),
			render: (workplaces) => getWorkplaceNumbers(workplaces) || '—'
		},
		{
			title: 'Изменить',
			key: 'edit',
			align: 'center',
			render: (_, record) => (
				<button className={styles.iconButton}
					onClick={() => {
						setSelectedUser(record);
						setCreateModalOpen(true);
					}}
				>
					<img
						className={styles.iconImage}
						src="/icons/edit-icon.svg"
						alt="edit"/>
				</button>
			)
		},
		{
			title: 'Удалить',
			key: 'delete',
			align: 'center',
			render: (_, record) => (
				<button className={styles.iconButton}
					onClick={() => {
						setSelectedUser(record);
						setDeleteModalOpen(true);
					}}
				>
					<img
						className={styles.iconImage}
						src="/icons/delete-icon.svg"
						alt="delete"/>
				</button>
			)
		}

	];
}
